import { Injectable,} from '@angular/core';
import { HttpParams, HttpErrorResponse, HttpClient} from '@angular/common/http';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { Observable} from 'rxjs';
import { environment } from '../environments/environment'; 
import { AuthServiceService } from './auth-service.service';
import "rxjs/add/observable/of";
import 'rxjs/add/operator/catch'; 

import Swal from 'sweetalert2';
import { MasterDataProviderService } from './master-data-provider.service';
@Injectable()
export class MainServiceService {
  authService;
  constructor(private router: Router, private http: HttpClient, authService:AuthServiceService, private masterDataProvider: MasterDataProviderService) { 
  this.authService=authService;
  }

  getFormInstance(q){
    let params = new HttpParams().set('q', q);
    return this.getAnyNew(environment.forms,params,true,false); 
  }
  saveForm(formQ,form,action){
    return this.putAny(environment.forms+'?q='+formQ+'&a='+action, form);
  }
  
  getRegDetails(mobileNum){
    return this.putAny(environment.registration, mobileNum);
  }
  saveRegistrationPayment(regPayData){
    return this.putAny(environment.registrationPayments, regPayData);
  }
  sendRegDetails(data) {        
    return this.getAny(environment.registration, data);
  }  

  getTodaySchedule(refresh) {
    return this.getAnyNew(environment.todaySchedule,null,refresh,true); 
  } 
  getClassroom(refresh) {
    return this.getAnyNew(environment.classroom,null,refresh,true); 
  } 
  getAssignment(refresh) {
  return this.getAnyNew(environment.assignments,null,refresh,true); 
  }
  getDiary(date,refresh) {
  let params = new HttpParams().set('date', date);
  return this.getAnyNew(environment.diary,params,refresh,true); 
  }
  getRemarks(refresh) {
    return this.getAnyNew(environment.remarks,null,refresh,true); 
  }
  
  getLiveMeetinLink(entityId,entityType) {
    let params = new HttpParams().set('entityId', entityId).set('entityType', entityType);
  return this.getAnyNew(environment.joinLive,params,true,false); 
  } 
  getCalender(refresh) {
    return this.getAnyNew(environment.monthsummary,null,refresh,true); 
    }

  getListOfExams(){
      return this.getAnyNew(environment.quizeUrl,null,true,false); 
  }
  getFee(refresh) {
    return this.getAnyNew(environment.fee,null,refresh,true); 
  }
  paymentLink(data){
    return this.putAny(environment.paymentLink,data);
  }
  updateProfile(data){
    return this.putAny(environment.profile,data);
  }
  getSchoolShoppe() {
    return this.getAnyNew(environment.schoolShoppe,null,true,false); 
  }
  getschoolShoppeCart() {
    return this.getAnyNew(environment.schoolShoppeCart,null,true,false); 
  }
  schoolShoppeCart(data) {
    return this.putAny(environment.schoolShoppeCart,data);
  }
  getschoolShoppeOrders() {
    return this.getAnyNew(environment.schoolShoppeOrders,null,true,false); 
  }
  schoolShoppeOrders(data) {
    return this.putAny(environment.schoolShoppeOrders,data);
  }
getOqPaper(entityId) {
    let params = new HttpParams().set('entityId', entityId);
    return this.getAnyNew(environment.oqPaperNew,params,true,false); 
  }
saveOqPaper(data) {
    return this.putAny(environment.oqPaperNew,data);
  }
submitOqPaper(data) {
    return this.putAny(environment.oqPaperSubmitNew,data);
  }
  /////////////////////Util functions /////////////////////

  handleError(error: HttpErrorResponse,router: Router) {
    let msg=error.message//"Something bad happened; please try again later."
    if(error.error){
      msg=error.error.message;
    }
    console.log('An error occurred:', error);
   if (error.error instanceof ErrorEvent) {
     console.log('An error occurred:', error.error.message);
     msg=error.error.message;
   } else { 
     if(error.status==401){
     msg="Session closed, please relogin";
     sessionStorage.removeItem('currentUser');
       var domain = sessionStorage.getItem('paramDomain');
       if(domain){
             let navigationExtras: NavigationExtras = {
                  queryParams: { 'domain': domain }                    
                   };
         this.router.navigate(['/login'], navigationExtras);
       }
     Swal('Error',msg,'error');
     }
   }
   // return an observable with a user-facing error message
   Swal('Error',msg,'error');
   //return null;//'Something bad happened; please try again later.';
    return Observable.create(observer => {
      observer.next(null);       
       observer.complete(); 
   })
 }
 
getAny(url, params) { 
  return this.getAnyNew(url, params,true,true);
}
 getAnyNew(url, params,reload,cahecble) { 
 if(!reload) {
   let data:string =this.masterDataProvider.getFromCache(url+params);   
   if(data!=null){
     // return cached data
     return Observable.create(observer => {
     setTimeout(() => {
       observer.next(data);       
       observer.complete();        
     }, 10);
   })
   }
 }
 return this.http.get(url,  {params:params}).map(response => {
     if(response){ 
       let data = JSON.stringify(response);
       if(cahecble){        
       this.masterDataProvider.cache(url+params,data);
     }
       return data;  
     }  
   }).catch(error=>{return this.handleError(error,this.router);}); 
 }  
  putAny(url, payload){
   return this.http.put(url, payload).map(response => {
     if(response){ 
       let data = JSON.stringify(response);
       return data; 
     }  
   }).catch(error=>{return this.handleError(error,this.router);}); 
 }


delete(url, params) {   
   return this.http.delete(url,  {params:params}).map(response => {
     if(response){ 
       let data = JSON.stringify(response);       
       return data;  
     }  
   }).catch(error=>{return this.handleError(error,this.router);}); 
 }  


download(url, params) {  
 return this.http.get(url,  {params:params}).map(response => {
     if(response){ 
       const json = JSON.parse(JSON.stringify(response));
       const blob = new Blob([json.objectData], {type: json.contentType});
       const link = document.createElement('a');
       link.href = URL.createObjectURL(blob);
       link.download = json.fileName;
       link.click();
       return json;  
     }  
   }).catch(error=>{return this.handleError(error,this.router);}); 
 } 


//   sendSMS(listofmsgs) {
//     var ListOfMessages = listofmsgs ;    
//     ListOfMessages.message=ListOfMessages.message;
//     return this.putAny(environment.approvals, listofmsgs);
//   }  
  
//   getApprovalRequests() {
//     return this.getAnyNew(environment.approvals,''); 
//   }
//   getApprovalRequestsHistory() {
//     return this.getAnyNew(environment.approvalsHistory,''); 
//   }
//    putApprovalRequests(data:any) {
//     return this.putAny(environment.approvals,data); 
//   }

//   getDailyAccountSummary() {
//     return this.getAnyNew(environment.dailyAccountSummary,''); 
//   }

//   changePassword(data:any) {
//     return this.putAny(environment.profile,data); 
//   }

//     /////////////////////Util functions /////////////////////
//   handleError(error: HttpErrorResponse,router: Router) {
//      let msg=error.message//"Something bad happened; please try again later."
//      if(error.error){
//        msg=error.error.message;
//      }
//      console.error('An error occurred:', error);
//     if (error.error instanceof ErrorEvent) {
//       console.error('An error occurred:', error.error.message);
//       msg=error.error.message;
//     } else { 
//       if(error.status==401){
//       msg="Session closed, please relogin";
//       sessionStorage.removeItem('currentUser');
//         var domain = sessionStorage.getItem('paramDomain');
//         if(domain){
//               let navigationExtras: NavigationExtras = {
//                    queryParams: { 'domain': domain }                    
//                     };
//           this.router.navigate(['/login'], navigationExtras);
//         }
//       Swal('Error',msg,'error');
//       }
//     }
//     // return an observable with a user-facing error message
//     Swal('Error',msg,'error');
//     return null;//'Something bad happened; please try again later.';
//   }
  
//  getAny(url, params) { 
//    return this.getAnyNew(url, params);
//  }
//   getAnyNew(url, params) { 
  
//     return this.http.get(url,  {params:params}).map(response => {
//       if(response){ 
//         let data = JSON.stringify(response);
//         return data;  
//       }  
//     }).catch(error=>{return this.handleError(error,this.router);}); 
//   }  
//    putAny(url, payload){
//     return this.http.put(url, payload).map(response => {
//       if(response){ 
//         let data = JSON.stringify(response);
//         return data; 
//       }  
//     }).catch(error=>{return this.handleError(error,this.router);}); 
//   }
}



// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/main-service.service.ts